function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3125 0.5H1.6875C1.24013 0.500595 0.811253 0.678576 0.494915 0.994915C0.178576 1.31125 0.000595304 1.74013 0 2.1875V26.375C0.000200741 26.59 0.0619855 26.8004 0.178041 26.9813C0.294096 27.1623 0.459563 27.3062 0.654856 27.396C0.850149 27.4858 1.06709 27.5178 1.28001 27.4882C1.49292 27.4586 1.69289 27.3686 1.85625 27.2289L9 21.1066L16.1438 27.2289C16.3072 27.3687 16.5073 27.4587 16.7203 27.4883C16.9333 27.5178 17.1503 27.4857 17.3457 27.3958C17.541 27.3058 17.7064 27.1617 17.8224 26.9806C17.9384 26.7995 18 26.5889 18 26.3739V2.1875C17.9994 1.74013 17.8214 1.31125 17.5051 0.994915C17.1887 0.678576 16.7599 0.500595 16.3125 0.5Z"
});

function SvgIcAreaBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaBookmark);
export default ForwardRef;